export function ParseDateRange(dstart, dend, list_menu){
    /*
    NotSet = 0
    AllTime = 1
    LastMonth = 2
    LastYear = 3
    * */

    let index_select_items = -1
    for(let ix=0;ix<list_menu.length; ix++){
        if ((list_menu[ix].range[0] == dstart)&&(list_menu[ix].range[1] == dend))
            index_select_items = ix
    }

    let resType = 0
    if(index_select_items == -1){
        return resType;
    }

    let item = list_menu[index_select_items].label.toLowerCase();

    if(item.includes('last month'))
        resType = 2
    else if (item.includes('last year'))
        resType = 3
    return resType
}